var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncomingShipment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1562_8727)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1562_8727)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1562_8727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.3999 0.400391H9.5999C4.51888 0.400391 0.399902 4.51937 0.399902 9.60039V70.4004C0.399902 75.4814 4.51888 79.6004 9.5999 79.6004H70.3999C75.4809 79.6004 79.5999 75.4814 79.5999 70.4004V9.60039C79.5999 4.51937 75.4809 0.400391 70.3999 0.400391Z",
    fill: "#F8FBFF",
    stroke: "#F0F2F5",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4286 35.3848H23.186V65.6756H56.4286V35.3848Z",
    fill: "#EAA123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7648 65.6752V59.9646H54.7586L53.219 57.4082L51.6787 59.9646H52.6728V65.6752H53.7648Z",
    fill: "#FFD4B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3641 65.6752V59.9646H50.3578L48.8175 57.4082L47.2783 59.9646H48.2724V65.6752H49.3641Z",
    fill: "#FFD4B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8734 35.3848H36.7407V65.6752H42.8734V35.3848Z",
    fill: "#FCBB4B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1861 35.3848H56.5247L64.7105 43.0718H15L23.1861 35.3848Z",
    fill: "#FFC766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4862 15V20.4441H47.7741L39.5812 34.0461L31.3887 20.4441H36.6766V15H42.4862Z",
    fill: "#3DB0C9"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1562_8727"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1562_8727"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1562_8727"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomingShipment);
export default __webpack_public_path__ + "static/media/incomingShipment.967f1f452208c26ebf2c07bdb76d5061.svg";
export { ForwardRef as ReactComponent };